module.exports = __webpack_public_path__ + "static/img/home_map_img2.203f15a8.png";